// extracted by mini-css-extract-plugin
module.exports = {"headingLarge":"PageNotFound_headingLarge_3wvlc","textLarge":"PageNotFound_textLarge_Lg9t8","centered":"PageNotFound_centered_1ui25"};